import React from "react"
import { navigate } from "vike/client/router"
import BlogCategories from "./categories"
import Typography from "aldoo-ra/Typography"
import Icon from "aldoo-ra/Icon"
import BlogSharePanel from "./share-panel"
import PageLike from "./page-like"
import Localization from "aldoo-ra/Localization"

const BlogPostHeader = ({ post = {} }) => {
  const { currentLanguage } = Localization()

  // DD.MM.YYYY in the time zone the dates are written in (an article dated
  // 19.12 is saved as midnight Sofia time): the same day on the server (UTC)
  // and in any visitor's browser, so the page hydrates as rendered
  const formatDate = (dateString) => {
    const date = new Date(dateString || "2024-10-23")
    const parts = Object.fromEntries(
      new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/Sofia", day: "2-digit", month: "2-digit", year: "numeric" })
        .formatToParts(date)
        .map(({ type, value }) => [type, value])
    )
    return `${parts.day}.${parts.month}.${parts.year}`
  }

  const handleCategoryClick = (category) => {
    if (category) {
      const langPrefix = currentLanguage && currentLanguage !== 'en' ? `/${currentLanguage}` : ''
      navigate(`${langPrefix}/blog?category=${encodeURIComponent(category.title)}`)
    }
  }
  const borderStyle = post.border ? "border-[2px] border-primary" : ""

  return (
    <div className="w-full lg:px-4 xl:px-8 mb-6 md:mb-10 lg:mb-[72px] xl:mb-[100px]">
      <div className="w-full max-w-[700px] md:max-w-w1_xl flex flex-col items-center justify-between lg:grid lg:grid-cols-2 lg:gap-10 xl:gap-[56px] mx-auto">
        <div
          className={`w-full max-w-[580px] md:max-w-[700px] lg:max-w-full h-auto aspect-[736/434] flex items-center justify-center flex-shrink-0 rounded-[12px] overflow-hidden mb-6 md:mb-10 lg:mb-0 ${borderStyle}`}
        >
          <img
            src={post.thumbnail}
            alt={post.title}
            className="w-full h-full object-cover"
          />
        </div>

        <div className="w-full max-w-[580px] md:max-w-[700px] lg:max-w-full lg:h-full flex flex-col items-start justify-between gap-5 lg:gap-0">
          <BlogCategories
            categories={post.category || []}
            onItemClick={handleCategoryClick}
          />
          <div>
            <Typography
              component="h1"
              variant="h3"
              className="text-text mb-1 xl:mb-2"
            >
              {post.title}
            </Typography>
            <div className="hidden md:flex items-center space-x-4">
              <PageLike target={post} />
              <div className="flex items-center justify-start gap-1">
                <Icon id="date" className="w-3 md:w-4 h-3 md:h-4 text-gray_1" />
                <Typography variant="info_12" className="text-gray_1 my-0">
                  {formatDate(post.publish_date)}
                </Typography>
              </div>
            </div>
          </div>
          <div className="hidden md:block pb-1">
            <BlogSharePanel 
              url={typeof window !== 'undefined' ? window.location.href : '#'} 
              title={post.title} 
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default BlogPostHeader
